import { render, staticRenderFns } from "./ChargingOrderExpand.vue?vue&type=template&id=bb748354&scoped=true&"
import script from "./ChargingOrderExpand.vue?vue&type=script&lang=js&"
export * from "./ChargingOrderExpand.vue?vue&type=script&lang=js&"
import style0 from "./ChargingOrderExpand.vue?vue&type=style&index=0&id=bb748354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb748354",
  null
  
)

export default component.exports